import React from 'react';
import AboutSection from '../../components/features/About/AboutSection';
import './About.css';

function About() {
    return (
        <div className="about-page">
            <AboutSection />
        </div>
    );
}

export default About; 